import { BottomNavigation, BottomNavigationAction, Paper, Typography } from '@mui/material';
import React from 'react';
import { useLocation, Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

const PassportPageBottom: React.FC = () => {
  const location = useLocation();
  const { t } = useTranslation();
  return (
      <Paper sx={{ position: 'fixed', bottom: 0, left: 0, right: 0 }} elevation={3}>
        <BottomNavigation showLabels value={location.pathname}>
          <BottomNavigationAction label={t('passportPage.labels.sections.qrcode')} icon={<img src='/icon_qrcode.svg' alt={t('passportPage.labels.sections.qrcode')} />} component={Link} to="/profile" value="/profile" />
          <BottomNavigationAction label={t('passportPage.labels.sections.qualification')} icon={<img src='/icon_qualification.svg' alt={t('passportPage.labels.sections.qualification')} /> } component={Link} to="/qualification" value="/qualification" />
          <BottomNavigationAction label={t('passportPage.labels.sections.settings')} icon={<img src='/icon_settings.svg' alt={t('passportPage.labels.sections.settings')} />} component={Link} to="/settings" value="/settings" />
        </BottomNavigation>
      </Paper>
  );
};

export default PassportPageBottom;
